/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AgentGoal,
  EntityId,
  SearchAIAnswerStream,
  SearchAIRecommendedQuestionStream,
  SiteInsightsSession,
  SiteSearchScope,
} from "./data-contracts";

/**
 * @description The response is streamed.
 * @tags site-ask
 * @name StreamAskInSite
 * @summary Ask a question in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/ask
 * @secure
 */

// @ts-ignore
export const streamAskInSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: {
    /** @maxLength 512 */
    question: string;
    /** You may optionally provide additional information about the context of the question. This doesn't affect the scope of the search, but GitBook may use this information to provide a better answer. Generally speaking, you should provide as much context as possible. */
    context?: {
      siteSpaceId?: string;
      /** The end goal the agent is trying to accomplish on behalf of the user. Unlike the question, which is the immediate query, the goal describes the broader task or outcome the agent is working towards. GitBook uses this to steer the answer towards what is ultimately useful for that goal. */
      goal?: AgentGoal;
    };
    scope: SiteSearchScope;
    /** Identifiers for a GitBook site session, used for analytics and adaptive content. */
    session?: SiteInsightsSession;
  };
  RequestHeaders: {
    /**
     * User agent of the visitor, when calling on behalf of one, such as from a server rendering a
     * docs site. When omitted, the request's own `User-Agent` is used.
     */
    "X-Original-User-Agent"?: string;
    /**
     * `Signature-Agent` header sent by the visitor, when calling on behalf of one, for agents that
     * sign their requests. When omitted, the request's own `Signature-Agent` is used.
     * https://datatracker.ietf.org/doc/draft-meunier-web-bot-auth-architecture/
     */
    "X-Original-Signature-Agent"?: string;
  };
  ResponseBody: SearchAIAnswerStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ask",
  method: "post",
  streaming: true,
  tags: ["site-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description The response is streamed.
 * @tags site-ask
 * @name StreamRecommendedQuestionsInSite
 * @summary List recommended questions to ask in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/ask/questions
 * @secure
 */

// @ts-ignore
export const streamRecommendedQuestionsInSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The ID of the site space to filter the recommended questions for. */
    siteSpaceId?: string;
    /**
     * The ID of the space to filter the recommended questions for.
     * @deprecated
     */
    spaceId?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SearchAIRecommendedQuestionStream;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ask/questions",
  method: "get",
  streaming: true,
  tags: ["site-ask"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
